// Specialisme-landingspagina's. Gestructureerd voor GEO-citatie: cijfers, FAQ en case study.

export const specialismes = {
  'interim-financial-controller': {
    slug: 'interim-financial-controller',
    discipline: 'Finance',
    title: 'Interim Financial Controller inhuren',
    h1: 'Interim Financial Controller in Amsterdam en Nederland',
    metaTitle: 'Interim Financial Controller inhuren Amsterdam – Staffing Force',
    metaDescription:
      'Interim financial controller nodig in Amsterdam of elders in Nederland? Staffing Force levert een shortlist binnen 48–72 uur. Tarieven, doorlooptijd en sectoren op één pagina.',
    keywords: [
      'interim financial controller',
      'interim controller Amsterdam',
      'financial controller inhuren',
      'tarief interim controller',
    ],
    heroImage:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1920&q=85&auto=format&fit=crop',
    intro:
      'Een interim financial controller inhuren in Amsterdam is vaak de snelste manier om uw finance-afdeling weer op volle sterkte te brengen. Of u nu een maandafsluiting moet redden, een ERP-migratie wilt begeleiden of een vacature moet overbruggen — Staffing Force levert binnen 48 tot 72 uur een shortlist met direct beschikbare professionals. Onze interim controllers werken voor scale-ups, multinationals en mkb-organisaties in heel Nederland.',
    metrics: [
      { value: '48–72u', label: 'Shortlist beschikbaar' },
      { value: '500+', label: 'Finance professionals in netwerk' },
      { value: '€85–€140', label: 'Uurtarief 2026' },
      { value: '6–9 mnd', label: 'Gemiddelde opdrachtduur' },
    ],
    tarievenTabel: [
      { niveau: 'Medior controller', tarief: '€ 85 – € 100 per uur', toelichting: '3–5 jaar ervaring, ondersteunende rol' },
      { niveau: 'Senior controller', tarief: '€ 110 – € 130 per uur', toelichting: 'Zelfstandig, IFRS of consolidatie' },
      { niveau: 'Group / Finance Manager', tarief: '€ 130 – € 160 per uur', toelichting: 'Leidinggevend, internationale rapportages' },
      { niveau: 'Specialist (M&A, ERP, IFRS-expert)', tarief: '+ 10–20% opslag', toelichting: 'Op basis van senior tarief' },
    ],
    sections: [
      {
        heading: 'Wat doet een interim financial controller?',
        body: 'Een financial controller bewaakt de financiële gezondheid van de organisatie: maandafsluitingen, rapportages, budgetbewaking, interne controle en het begeleiden van audits. In interim-vorm wordt hij of zij ingezet voor piekbelasting, een onverwachte uitval, een transformatietraject of om specifieke expertise (IFRS, consolidatie, ERP-implementatie) tijdelijk aan boord te brengen.',
      },
      {
        heading: 'Voor welke sectoren werken onze interim controllers?',
        body: 'Onze interim financial controllers werken voor opdrachtgevers in scale-ups en techbedrijven, retail en e-commerce, internationale hoofdkantoren in Amsterdam, productie en groothandel, en zorg en non-profit. De dichtheid aan internationale hoofdkantoren in de Randstad maakt dat veel opdrachten een IFRS- of consolidatie-component hebben.',
      },
      {
        heading: 'Doorlooptijd: hoe snel kan een interim controller starten?',
        body: 'Via Staffing Force ontvangt u binnen 48 tot 72 uur een shortlist. Een kandidaat zonder opzegtermijn kan binnen een week starten. Kandidaten die een lopende opdracht afronden hebben gemiddeld twee tot vier weken nodig.',
      },
      {
        heading: 'Waarom Staffing Force?',
        body: 'Staffing Force is sinds 2007 gespecialiseerd in Finance, HR en Duurzaamheid — geen generieke uitzending. U krijgt een vaste contactpersoon, kandidaten zijn gescreend op vaktechniek én cultural fit, en de gemiddelde detavast-conversie naar vast dienstverband is 85%. Staffing Force is NEN 4400-1 gecertificeerd en was als eerste detacheerder in Nederland B Corp gecertificeerd (2023–2025).',
      },
    ],
    caseStudy: {
      sector: 'Internationaal hoofdkantoor – retail (Amsterdam)',
      challenge:
        'Plotselinge uitval van de senior controller drie weken voor de kwartaalsluiting van een beursgenoteerde retailer.',
      doorlooptijd: 'Shortlist binnen 36 uur, start na 5 werkdagen.',
      resultaat:
        'Kwartaalsluiting op tijd opgeleverd, vervolgens 9 maanden interim met succesvolle overdracht aan de nieuwe vaste controller.',
    },
    faqs: [
      { q: 'Wat kost een interim financial controller in Amsterdam?', a: 'In 2026 liggen de tarieven tussen €85 (medior) en €140+ (senior met specialisatie) per uur, afhankelijk van ervaring en opdrachtcomplexiteit.' },
      { q: 'Hoe snel kan Staffing Force een interim controller leveren?', a: 'Doorgaans binnen 48 tot 72 uur een shortlist. Start binnen een week is haalbaar bij kandidaten zonder opzegtermijn.' },
      { q: 'Wat is het verschil tussen een financial controller en een business controller?', a: 'Een financial controller is verantwoordelijk voor de cijfers (rapportage, controle, audit). Een business controller vertaalt cijfers naar strategie en stuurt actief de business aan via analyses en forecasts.' },
      { q: 'Kan een interim controller overgaan naar vast dienstverband?', a: 'Ja, via onze detavast-constructie. De conversie naar vast dienstverband ligt bij 85% van de detavast-trajecten.' },
    ],
  },

  'hr-business-partner': {
    slug: 'hr-business-partner',
    discipline: 'HR',
    title: 'HR Business Partner inhuren',
    h1: 'Interim HR Business Partner detachering – Amsterdam & Nederland',
    metaTitle: 'HR Business Partner detachering – Staffing Force Amsterdam',
    metaDescription:
      'HR Business Partner inhuren voor transformatie, scale-up of overbrugging? Staffing Force levert ervaren interim HRBP\'s in Amsterdam en heel Nederland.',
    keywords: ['HR Business Partner detachering', 'HRBP inhuren', 'interim HR Amsterdam'],
    heroImage:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=85&auto=format&fit=crop',
    intro:
      'Een HR Business Partner inhuren is de juiste keuze wanneer uw organisatie groeit, transformeert of behoefte heeft aan strategisch HR-advies op directieniveau. Staffing Force levert ervaren interim HRBP\'s in Amsterdam en heel Nederland, met track records bij scale-ups, internationale organisaties en mkb in transformatie.',
    metrics: [
      { value: '48–72u', label: 'Shortlist beschikbaar' },
      { value: '€95–€145', label: 'Uurtarief 2026' },
      { value: '6–12 mnd', label: 'Gemiddelde opdrachtduur' },
      { value: '85%', label: 'Detavast-conversie naar vast' },
    ],
    tarievenTabel: [
      { niveau: 'Medior HRBP', tarief: '€ 95 – € 115 per uur', toelichting: '5–8 jaar HR-ervaring' },
      { niveau: 'Senior HRBP', tarief: '€ 120 – € 140 per uur', toelichting: '10+ jaar, sparring op directieniveau' },
      { niveau: 'Specialist (M&A, change, internationaal)', tarief: '+ 10–15%', toelichting: 'Op basis van senior tarief' },
    ],
    sections: [
      {
        heading: 'Wat doet een HR Business Partner?',
        body: 'Een HR Business Partner (HRBP) is het strategische aanspreekpunt voor het management over alle people-onderwerpen: organisatieontwikkeling, talent management, performance, change management en arbeidsverhoudingen. Anders dan een operationeel HR-adviseur denkt de HRBP mee op directieniveau.',
      },
      {
        heading: 'Wanneer kiest u voor interim, detavast of werving & selectie?',
        body: 'Interim past bij een tijdelijke behoefte: zwangerschapsvervanging, ziekteverlof, een transformatieproject van maximaal twaalf maanden. Detavast is geschikt als u op zoek bent naar een vaste HRBP maar het zekere voor het onzekere wilt: de professional start gedetacheerd, en kan na zes tot twaalf maanden in vaste dienst overstappen. Werving & selectie past bij een direct vaste invulling.',
      },
      {
        heading: 'Welke ervaring zoeken wij in onze HRBP\'s?',
        body: 'Onze interim HR Business Partners hebben gemiddeld acht tot vijftien jaar HR-ervaring, een bewezen track record in vergelijkbare sectoren, en sterke business-acumen. Ze worden geselecteerd op HR-vaktechniek, business sense, en stakeholdermanagement op directieniveau.',
      },
    ],
    caseStudy: {
      sector: 'Scale-up tech – 250 medewerkers (Amsterdam)',
      challenge:
        'Snelle internationale groei zonder strategische HR-functie; behoefte aan professionalisering van talent management en arbeidsvoorwaarden.',
      doorlooptijd: 'Shortlist binnen 72 uur, start na 2 weken.',
      resultaat:
        'In 9 maanden HR-strategie geïmplementeerd, eerste people-cyclus opgezet, succesvolle overdracht aan een vaste HRBP via detavast.',
    },
    faqs: [
      { q: 'Wat kost een interim HR Business Partner?', a: 'Tussen €95 en €145 per uur in 2026, afhankelijk van ervaring en specialisatie.' },
      { q: 'Wat is het verschil tussen een HR Business Partner en een HR Manager?', a: 'Een HR Manager heeft operationele leiding over een HR-team en focust op uitvoering en beleid. Een HRBP is strategisch sparringpartner van het lijnmanagement en heeft meestal geen directe leidinggevende rol.' },
      { q: 'Hoe lang duurt een gemiddelde HRBP-opdracht?', a: 'Zes tot twaalf maanden. Transformatie- en M&A-trajecten kunnen langer lopen.' },
      { q: 'Kan een interim HRBP overstappen naar vast dienstverband?', a: 'Ja, via onze detavast-constructie — 85% van de detavast-trajecten resulteert in een vaste aanstelling.' },
    ],
  },

  'csrd-consultant': {
    slug: 'csrd-consultant',
    discipline: 'Duurzaamheid',
    title: 'CSRD-consultant inhuren',
    h1: 'CSRD-consultant inhuren in Nederland',
    metaTitle: 'CSRD-consultant inhuren – Staffing Force Nederland',
    metaDescription:
      'CSRD-rapportage opzetten? Staffing Force levert ervaren CSRD-consultants en ESG-specialisten in Amsterdam en heel Nederland.',
    keywords: ['CSRD consultant inhuren', 'ESG consultant Nederland', 'CSRD rapportage'],
    heroImage:
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&q=85&auto=format&fit=crop',
    intro:
      'CSRD-rapportage is voor grote ondernemingen verplicht vanaf boekjaar 2025. Staffing Force levert gespecialiseerde CSRD-consultants en ESG-experts die uw rapportagetraject van A tot Z begeleiden, in Amsterdam en heel Nederland.',
    metrics: [
      { value: '6–12 mnd', label: 'Doorlooptijd eerste CSRD-rapport' },
      { value: '€110–€165', label: 'Uurtarief 2026' },
      { value: '80–200u', label: 'Consultancy CSRD-impactanalyse' },
      { value: 'B Corp', label: 'Gecertificeerd 2023–2025' },
    ],
    tarievenTabel: [
      { niveau: 'Medior ESG-consultant', tarief: '€ 110 – € 130 per uur', toelichting: 'Praktische data en rapportage' },
      { niveau: 'Senior CSRD-specialist', tarief: '€ 135 – € 160 per uur', toelichting: 'Materialiteitsanalyse, ESRS' },
      { niveau: 'Partner-niveau (audit-ervaring)', tarief: '€ 160+ per uur', toelichting: 'ESRS-expert, assurance-voorbereiding' },
    ],
    sections: [
      {
        heading: 'Wat doet een CSRD-consultant?',
        body: 'Een CSRD-consultant begeleidt organisaties bij het opzetten en uitvoeren van rapportage onder de Corporate Sustainability Reporting Directive. Concreet: dubbele-materialiteitsanalyse uitvoeren, gap-analyse op datapunten, datacollectie inrichten, ESG-strategie aanscherpen, en het opstellen van de CSRD-rapportage volgens de European Sustainability Reporting Standards (ESRS).',
      },
      {
        heading: 'Wanneer is CSRD verplicht?',
        body: 'Beursgenoteerde grote ondernemingen rapporteerden over boekjaar 2024. Grote ondernemingen (>250 medewerkers, >€50M omzet of >€25M balans) zijn verplicht vanaf boekjaar 2025. Beursgenoteerde mkb-bedrijven volgen in 2026. Niet-EU ondernemingen met EU-omzet >€150M volgen in 2028.',
      },
      {
        heading: 'Hoe ziet een CSRD-traject eruit?',
        body: 'Een typisch CSRD-traject bestaat uit vier fasen: (1) dubbele-materialiteitsanalyse — vaststellen welke duurzaamheidsthema\'s relevant zijn; (2) gap-analyse — in kaart brengen welke datapunten ontbreken; (3) datacollectie en proces-inrichting — KPI\'s definiëren, dataeigenaren benoemen; (4) rapportage en assurance — opstellen van de CSRD-rapportage en voorbereiden op de verplichte limited assurance.',
      },
      {
        heading: 'Waarom Staffing Force voor CSRD?',
        body: 'Staffing Force was als eerste detacheringsbureau in Nederland B Corp gecertificeerd (2023–2025) en heeft een eigen team Duurzaamheidsprofessionals. Onze consultants combineren ESG-kennis met praktijkervaring in finance en assurance — cruciaal voor CSRD.',
      },
    ],
    caseStudy: {
      sector: 'Productiebedrijf – 400 medewerkers (Nederland)',
      challenge:
        'Eerste CSRD-rapportage opzetten zonder bestaande duurzaamheidsorganisatie. Beperkte datakwaliteit, fragmentatie tussen vestigingen.',
      doorlooptijd: 'Start binnen 2 weken, traject van 9 maanden.',
      resultaat:
        'Eerste CSRD-rapportage tijdig opgeleverd, dubbele-materialiteitsanalyse geaccepteerd door auditor.',
    },
    faqs: [
      { q: 'Wanneer is CSRD-rapportage verplicht voor mijn bedrijf?', a: 'Beursgenoteerde grote ondernemingen rapporteerden over 2024. Grote ondernemingen (>250 medewerkers) zijn verplicht vanaf boekjaar 2025. Beursgenoteerde mkb-bedrijven volgen in 2026.' },
      { q: 'Hoeveel kost een complete CSRD-rapportage?', a: 'Voor een middelgrote organisatie rekent u op 80 tot 200 consultancy-uren over drie tot zes maanden. Bij een uurtarief van €110–€165 komt dat neer op €9.000 tot €33.000+ aan consultancy.' },
      { q: 'Wat is een dubbele-materialiteitsanalyse?', a: 'Een analyse die voor elk duurzaamheidsthema zowel de impact op de organisatie als de impact van de organisatie op mens en milieu beoordeelt. Het is de eerste stap in elk CSRD-traject.' },
      { q: 'Wat is het verschil tussen CSRD en EU Taxonomy?', a: 'CSRD is een rapportageverplichting. EU Taxonomy is een classificatiesysteem dat definieert wanneer een economische activiteit als duurzaam telt. EU Taxonomy-rapportage is een onderdeel van de CSRD-verplichting.' },
    ],
  },
};
